import { useEffect } from 'react';
import { JobSearch } from '@/components/partial/job-search';
import { useUpdateUserJobs } from '@/data/account/user-jobs';
import { ProfileStepIds } from '@/models/recommendation';
import { JobType, type JobTitle } from '@/models/taxonomy/job';
import { BaseQuestion } from '@/packages/profile-quiz/components/questions/base-question';
import { useProfileQuiz } from '@/packages/profile-quiz/context/profile-quiz';
import type { QuestionProps } from '@/packages/profile-quiz/context/profile-quiz/types';
import { ProfileFields } from '@/packages/profile-quiz/context/profile-quiz/types';

export const CurrentJobStep = (_props: QuestionProps) => {
  const { answers, setQuizAnswer, setCurrentStepValid } = useProfileQuiz();
  const { mutate: updateUserJobs } = useUpdateUserJobs();

  const processedResponseText =
    'Perfeito! Com isso já consigo mapear suas funções e as habilidades necessárias para o seu dia a dia.';
  const questionText = '💼 Qual é o seu cargo atual?';

  const setCurrentJob = (value: JobTitle | null) => {
    if (value?.id) {
      setQuizAnswer(ProfileFields.CurrentJob, value);
      updateUserJobs({
        title_id: value.id,
        job_type: JobType.Current,
      });

      setCurrentStepValid(true);
    }
  };

  useEffect(() => {
    const isValid =
      answers.current_job !== null &&
      (answers.current_job?.name?.trim().length ?? 0) > 0;
    setCurrentStepValid(isValid);
  }, [answers.current_job, setCurrentStepValid]);

  return (
    <BaseQuestion
      questionTitle={questionText}
      questionId={ProfileStepIds.CurrentJob}
      processedResponseText={processedResponseText}
    >
      <JobSearch
        jobTitle={answers.current_job ?? null}
        onSelect={setCurrentJob}
      />
    </BaseQuestion>
  );
};
